import { Button } from "@shared/components/ui/Button";
import theme from "@shared/utils/themeColors";
import { Link } from "react-router-dom";

// Login form component
const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  onSubmit,
  loading,
  error,
  needsVerification,
  handleVerificationRedirect,
}) => (
  <>
    <h1 className={`text-3xl ${theme.text.primary} mb-6 font-petrona`}>
      Welcome back!
    </h1>

    {/* Error message */}
    {error && (
      <div className="mb-4">
        <div className="bg-red-50 border-l-4 border-red-400 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-red-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          </div>
        </div>
      </div>
    )}

    {needsVerification && (
      <div className="mt-4 text-center max-w-md mx-auto mb-4">
        <button
          onClick={handleVerificationRedirect}
          className={`text-sm ${theme.text.link} hover:underline`}
        >
          Need to verify your email? Click here
        </button>
      </div>
    )}

    {/* Form */}
    <form onSubmit={onSubmit}>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1" htmlFor="email">
            Email Address
          </label>
          <input
            id="email"
            className="form-input w-full"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="form-input w-full"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="on"
            required
          />
        </div>
      </div>
      <div className="flex items-center justify-between mt-6">
        <div className="mr-1">
          <Link className={`text-sm ${theme.text.link}`} to="/reset-password">
            Forgot Password?
          </Link>
        </div>
        <Button
          type="submit"
          variant="primary"
          isLoading={loading}
          loadingText="Signing in..."
        >
          Sign In
        </Button>
      </div>
    </form>

    <div className="pt-5 mt-6 border-t border-gray-200">
      <div className="text-sm">
        Need an invitation?{" "}
        <a
          className={`font-medium ${theme.text.link} hover:underline inline-flex items-center`}
          href="https://www.globalcca.org/contact"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact us
          <span aria-hidden="true" className="ml-1">→</span>
        </a>
      </div>
    </div>
  </>
);

export default LoginForm;
